export default "__VITE_ASSET__Cnt4WG8E__"